// Flowers Denim: drawers, búsqueda, carrito (Ajax API de Shopify), catálogo y página de producto.
(() => {
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const FD = window.FD;

  // ---------- Drawers ----------
  function openDrawer(id) {
    closeDrawers();
    const d = document.getElementById(id);
    if (!d) return;
    d.classList.add('open');
    $('.scrim').classList.add('open');
    document.documentElement.classList.add('lock');
    if (id === 'search') setTimeout(() => $('#search input[name=q]').focus(), 200);
    if (id === 'cart') refreshCart();
  }
  function closeDrawers() {
    $$('.drawer.open, .scrim.open').forEach(el => el.classList.remove('open'));
    document.documentElement.classList.remove('lock');
  }
  document.addEventListener('click', e => {
    const open = e.target.closest('[data-open]');
    if (open) { e.preventDefault(); openDrawer(open.dataset.open); return; }
    if (e.target.closest('[data-close]')) closeDrawers();
    if (e.target.closest('[data-top]')) scrollTo({ top: 0, behavior: 'smooth' });
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawers(); });

  let toastTimer;
  function toast(msg) {
    const t = $('.toast');
    t.innerHTML = msg;
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => t.classList.remove('show'), 2600);
  }
  const esc = s => String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  // ---------- Búsqueda predictiva ----------
  const searchInput = $('#search input[name=q]');
  const searchBox = $('.search-results');
  let searchTimer;
  async function runSearch(q) {
    if (!q.trim()) { searchBox.innerHTML = ''; return; }
    try {
      const r = await fetch(`${FD.routes.search}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=10`);
      const data = await r.json();
      const list = data.resources?.results?.products || [];
      searchBox.innerHTML = list.length
        ? `<div class="search-grid">${list.map(p => `
            <a href="${p.url}" class="search-item">${p.image ? `<img src="${p.image}" alt="" loading="lazy">` : ''}<span>${esc(p.title)}</span></a>`).join('')}</div>`
        : '<p class="search-hint">No encontramos productos para tu búsqueda.</p>';
    } catch { searchBox.innerHTML = ''; }
  }
  searchInput?.addEventListener('input', () => {
    clearTimeout(searchTimer);
    searchTimer = setTimeout(() => runSearch(searchInput.value), 200);
  });

  // ---------- Carrito ----------
  async function getCart() { return (await fetch(`${FD.routes.cart}.js`)).json(); }
  const prendas = cart => cart.item_count;
  const money = cents => `$${(cents / 100).toLocaleString('es-AR', { maximumFractionDigits: 2 })}`;

  function setBadge(n) {
    const b = $('.header .badge');
    b.hidden = !n;
    b.textContent = n;
  }

  function renderCart(cart, body = $('#cart .cart-body')) {
    if (!body) return;
    const total = prendas(cart);
    if (!total) {
      body.innerHTML = `<p class="cart-empty">Tu pedido está vacío.<br>Recordá que la compra mínima es de ${FD.minimo} prendas.</p>`;
      return;
    }
    const falta = Math.max(0, FD.minimo - total);
    const pct = Math.min(100, total / FD.minimo * 100);
    body.innerHTML = `
      <div class="cart-progress">
        <p>${falta ? `Te ${falta === 1 ? 'falta <b>1</b> prenda' : `faltan <b>${falta}</b> prendas`} para llegar al mínimo de ${FD.minimo}.` : '<b>¡Listo!</b> Llegaste a la compra mínima.'}</p>
        <div class="bar"><i style="width:${pct}%"></i></div>
      </div>
      <ul class="cart-list">${cart.items.map((it, idx) => `
        <li class="cart-item">
          <a href="${it.url}">${it.image ? `<img src="${it.image}${it.image.includes('?') ? '&' : '?'}width=200" alt="">` : ''}</a>
          <div class="ci-info">
            <a href="${it.url}" class="ci-name">${esc(it.product_title)}</a>
            <span class="ci-meta">Talle ${esc(it.variant_title || '')} · ${money(it.final_price)} c/u</span>
            <div class="qty"><button data-line="${idx + 1}" data-qty="${it.quantity - 1}" aria-label="Restar">−</button><span>${it.quantity}</span><button data-line="${idx + 1}" data-qty="${it.quantity + 1}" aria-label="Sumar">+</button></div>
          </div>
        </li>`).join('')}</ul>
      <div class="cart-foot">
        <div class="cart-total"><span>Prendas</span><b>${total}</b></div>
        <div class="cart-total cart-amount"><span>Total</span><b>${money(cart.total_price)}</b></div>
        ${falta ? '<button class="add" disabled>Finalizar compra</button>' : `<a class="add" href="${FD.routes.cart}">Finalizar compra</a>`}
        <p class="cart-pay">Pagás con tarjeta de débito o crédito en 1 pago, o en efectivo al retirar en el local.</p>
      </div>`;
    $$('[data-line]', body).forEach(b => b.onclick = async () => {
      const r = await fetch(`${FD.routes.cartChange}.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: +b.dataset.line, quantity: +b.dataset.qty }),
      });
      const c = await r.json();
      setBadge(prendas(c));
      $$('.cart-body').forEach(el => renderCart(c, el));
      document.dispatchEvent(new Event('fd:cart'));
    });
  }

  async function refreshCart() {
    const c = await getCart();
    setBadge(prendas(c));
    $$('.cart-body').forEach(el => renderCart(c, el));
    return c;
  }

  // items: [{ id, quantity }]. Devuelve true si se agregó.
  async function addToCart(items, name, detalle) {
    const r = await fetch(`${FD.routes.cartAdd}.js`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items.map(i => ({ id: +i.id, quantity: i.quantity })) }),
    });
    if (!r.ok) { toast('No pudimos agregar las prendas. Probá de nuevo.'); return false; }
    const c = await refreshCart();
    document.dispatchEvent(new Event('fd:cart'));
    const n = prendas(c);
    const falta = FD.minimo - n;
    toast(`<b>${esc(name)}</b> · ${esc(detalle)}.<br>${falta > 0 ? `Llevás ${n} · ${falta === 1 ? 'falta 1' : `faltan ${falta}`} para el mínimo.` : `Llevás ${n} prendas · ¡mínimo alcanzado!`}`);
    return true;
  }

  // ---------- Finalizar compra (/cart) ----------
  const coRoot = $('.co-root');
  if (coRoot && window.FDCheckout) {
    const checkout = FDCheckout.init({
      root: coRoot,
      minimo: FD.minimo,
      whatsapp: FD.whatsapp,
      homeUrl: FD.routes.root,
      checkoutUrl: '/checkout',
      getItems: async () => (await getCart()).items.map(it => ({
        img: it.image ? `${it.image}${it.image.includes('?') ? '&' : '?'}width=200` : '',
        name: it.product_title,
        art: it.sku ? it.sku.replace(/-[^-]+$/, '') : it.product_title,
        talle: it.variant_title || '',
        qty: it.quantity,
        price: it.final_price ? it.final_price / 100 : null,
        url: it.url,
      })),
      saveOrder: ({ attributes, note }) => fetch(`${FD.routes.cart}/update.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes, note }),
      }),
      editCart: () => openDrawer('cart'),
      clearCart: () => fetch(`${FD.routes.cart}/clear.js`, { method: 'POST' }),
    });
    document.addEventListener('fd:cart', () => checkout.refresh());
  }

  // ---------- Tarjetas: agregado rápido ----------
  document.addEventListener('click', e => {
    const q = e.target.closest('[data-quick]');
    if (q) {
      const card = q.closest('.card');
      const wasOpen = card.classList.contains('quick-open');
      $$('.card.quick-open').forEach(c => c.classList.remove('quick-open'));
      if (!wasOpen) card.classList.add('quick-open');
      return;
    }
    const add = e.target.closest('[data-add]');
    if (add) {
      addToCart([{ id: add.dataset.add, quantity: 1 }], add.dataset.name, `Talle ${add.dataset.talle} agregado`);
      add.closest('.card').classList.remove('quick-open');
    }
  });

  // ---------- Catálogo ----------
  const grid = $('.catalog .grid');
  if (grid) {
    const cards = $$('.card', grid);
    const state = { sort: 'destacados', colores: new Set() };
    const SORTS = {
      destacados: () => 0,
      art: (a, b) => a.dataset.art.localeCompare(b.dataset.art),
    };

    function applyGrid() {
      const order = cards.map((c, i) => [c, i]).sort(([a, ia], [b, ib]) => SORTS[state.sort](a, b) || ia - ib);
      let n = 0;
      order.forEach(([c]) => {
        const show = !state.colores.size || state.colores.has(c.dataset.color);
        c.hidden = !show;
        if (show) n++;
        grid.appendChild(c);
      });
      $('.count').textContent = `${n} producto${n === 1 ? '' : 's'}`;
      $('.filter-btn .n').textContent = state.colores.size ? `(${state.colores.size})` : '';
    }

    // Columnas
    const mobile = matchMedia('(max-width: 1025px)').matches;
    const icons = {
      1: '<rect x="3.5" y="3.5" width="17" height="17"/>',
      2: '<rect x="3.5" y="3.5" width="17" height="17"/><path d="M12 3.5v17"/>',
      3: '<rect x="3.5" y="3.5" width="17" height="17"/><path d="M9.2 3.5v17M14.8 3.5v17"/>',
      4: '<rect x="3.5" y="3.5" width="17" height="17"/><path d="M12 3.5v17M3.5 12h17"/>',
    };
    $('.views').innerHTML = (mobile ? [1, 2] : [2, 3, 4]).map(n =>
      `<button class="view-btn" data-cols="${n}" aria-label="${n} por fila"><svg viewBox="0 0 24 24" fill="none" stroke-width="1.3">${icons[n]}</svg></button>`).join('');
    const setCols = n => {
      grid.style.setProperty('--cols', n);
      $$('.view-btn').forEach(b => b.classList.toggle('active', +b.dataset.cols === n));
    };
    $$('.view-btn').forEach(b => b.onclick = () => setCols(+b.dataset.cols));
    setCols(mobile ? 2 : 4);

    // Ordenar
    const sort = $('.sort');
    $('.sort-toggle').onclick = e => { e.stopPropagation(); sort.classList.toggle('open'); };
    $$('[data-sort]').forEach(b => b.onclick = () => {
      state.sort = b.dataset.sort;
      $$('[data-sort]').forEach(x => x.classList.toggle('active', x === b));
      sort.classList.remove('open');
      applyGrid();
    });
    document.addEventListener('click', () => sort.classList.remove('open'));

    // Filtro por color
    const colors = new Map();
    cards.forEach(c => {
      if (!c.dataset.color) return;
      const sw = $('.swatch', c).style.getPropertyValue('--c');
      const cur = colors.get(c.dataset.color) || { hex: sw, n: 0 };
      cur.n++;
      colors.set(c.dataset.color, cur);
    });
    const renderFilters = () => {
      $('.filter-body').innerHTML = `
        <p class="opt-label">Color</p>
        <div class="filter-list">${[...colors].map(([name, { hex, n }]) => `
          <label class="check"><input type="checkbox" value="${esc(name)}" ${state.colores.has(name) ? 'checked' : ''}>
            <span class="swatch" style="--c:${hex}"></span>${esc(name)}<em>${n}</em></label>`).join('')}</div>`;
      $$('.filter-body input').forEach(i => i.onchange = () => {
        i.checked ? state.colores.add(i.value) : state.colores.delete(i.value);
        applyGrid();
      });
    };
    renderFilters();
    $('.filter-clear').onclick = () => { state.colores.clear(); renderFilters(); applyGrid(); };
    applyGrid();

    // Carrusel de tipos
    const track = $('.cats-track');
    const updateArrows = () => {
      const over = track.scrollWidth > track.clientWidth + 2;
      $('.cats-arrow.l').hidden = !over || track.scrollLeft <= 2;
      $('.cats-arrow.r').hidden = !over || track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    };
    const active = $('.cat-slide.active', track);
    if (active) {
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = active.offsetLeft - (track.clientWidth - active.offsetWidth) / 2;
      track.style.scrollBehavior = '';
    }
    $('.cats-arrow.l').onclick = () => track.scrollBy({ left: -track.clientWidth * 0.6 });
    $('.cats-arrow.r').onclick = () => track.scrollBy({ left: track.clientWidth * 0.6 });
    track.addEventListener('scroll', updateArrows, { passive: true });
    addEventListener('resize', updateArrows);
    addEventListener('load', updateArrows);
    updateArrows();
  }

  // ---------- Producto ----------
  const pdp = $('.pdp');
  if (pdp) {
    // Cantidades por talle
    const cells = $$('.qcell[data-id]', pdp);
    const cant = new Map(cells.map(c => [c.dataset.id, 0]));
    const totalPrendas = () => [...cant.values()].reduce((a, b) => a + b, 0);
    const add = $('#add');
    const renderQty = () => {
      const n = totalPrendas();
      cells.forEach(c => {
        const q = cant.get(c.dataset.id);
        c.classList.toggle('on', q > 0);
        const input = $('input', c);
        if (document.activeElement !== input) input.value = q;
      });
      add.disabled = !n;
      add.textContent = n ? `Agregar ${n} ${n === 1 ? 'prenda' : 'prendas'} al pedido` : 'Elegí cantidades';
    };
    cells.forEach(c => {
      const id = c.dataset.id;
      $$('[data-d]', c).forEach(b => b.onclick = () => { cant.set(id, Math.max(0, cant.get(id) + +b.dataset.d)); renderQty(); });
      const input = $('input', c);
      input.oninput = () => { cant.set(id, Math.max(0, parseInt(input.value.replace(/\D/g, ''), 10) || 0)); renderQty(); };
      input.onblur = renderQty;
      input.onfocus = () => input.select();
    });
    add.onclick = async () => {
      const items = [...cant].filter(([, q]) => q > 0).map(([id, quantity]) => ({ id, quantity }));
      if (!items.length) return;
      const n = totalPrendas();
      add.disabled = true;
      if (await addToCart(items, add.dataset.name, `${n} ${n === 1 ? 'prenda agregada' : 'prendas agregadas'}`)) cant.forEach((_, k) => cant.set(k, 0));
      renderQty();
    };
    $('.share').onclick = async () => {
      const data = { title: document.title, url: location.href };
      if (navigator.share) { try { await navigator.share(data); } catch {} return; }
      try { await navigator.clipboard.writeText(location.href); toast('Link copiado'); } catch { toast(location.href); }
    };
    $$('.acc-head').forEach(h => h.onclick = () => h.parentElement.classList.toggle('open'));

    const gal = $('.gallery');
    gal.addEventListener('scroll', () => {
      const i = Math.round(gal.scrollLeft / gal.clientWidth);
      $$('.g-dots i').forEach((d, j) => d.classList.toggle('on', i === j));
    }, { passive: true });

    const fotos = $$('[data-zoom]').map(b => b.dataset.src);
    const zoom = $('#zoom');
    let zi = 0;
    const show = i => { zi = (i + fotos.length) % fotos.length; $('img', zoom).src = fotos[zi]; };
    const closeZoom = () => { zoom.classList.remove('open'); document.documentElement.classList.remove('lock'); };
    $$('[data-zoom]').forEach(b => b.onclick = () => { show(+b.dataset.zoom); zoom.classList.add('open'); document.documentElement.classList.add('lock'); });
    $('.z-prev').onclick = () => show(zi - 1);
    $('.z-next').onclick = () => show(zi + 1);
    $('.z-close').onclick = closeZoom;
    document.addEventListener('keydown', e => {
      if (!zoom.classList.contains('open')) return;
      if (e.key === 'Escape') closeZoom();
      if (e.key === 'ArrowLeft') show(zi - 1);
      if (e.key === 'ArrowRight') show(zi + 1);
    });
  }
})();
